const uploadSubmitErrorModalSupport = {
  label: 'Aguarde todos o arquivo subir'
};

export default uploadSubmitErrorModalSupport;
